// Values of the `preset` field sent to POST /customer/tokens.
// The backend defaults to INTEGRATION when the field is absent.
export const API_TOKEN_PRESETS = {
  INTEGRATION: 'integration',
  AI_ASSISTANT: 'ai_assistant'
};
